/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-24 23:52:19
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2023-10-10 23:40:22
 */
import request from '../request';

export function getMaterialCategoryList() {
    return request('/material/getMaterialCategoryList', {
        method: 'GET'
    });
}
export function getMaterialLabelList() {
    return request('/material/getMaterialLabelList', {
        method: 'GET'
    });
}
export function getMaterialFormatList() {
    return request('/material/getMaterialFormatList', {
        method: 'GET'
    });
}
export function getMaterialList(params) {
    return request('/material/getMaterialList', {
        method: 'GET',
        params
    });
}
export function getUserCollectionMaterials(params) {
    return request('/material/getUserCollectionMaterials', {
        method: 'GET',
        params
    });
}
export function collectMaterial(params) {
    return request('/material/collectionMaterial', {
        method: 'GET',
        params
    });
}

export function cancelCollectMaterial(params) {
    return request('/material/unCollectionMaterial', {
        method: 'GET',
        params
    });
}

export function downloadMaterial(id) {
    return request(`/material/download?materialId=${id}`, {
        method: 'POST'
    });
}

export function queryMaterialIsPayByUser(id) {
    return request(`/material/${id}/payed`, {
        method: 'GET'
    });
}

export function getUserMaterialPaid() {
    return request(`/material/payed`, {
        method: 'GET'
    });
}

export function getMyMaterial(params) {
    return request(`/material/mine/list`, {
        method: 'GET',
        params
    });
}

export function getMaterialDetail(params) {
    return request(`/material/getMaterialDetail`, {
        method: 'GET',
        params
    });
}

export function uploadMaterial(params) {
    return request(`/material/draft/upload`, {
        method: 'POST',
        params
    });
}

export function getUploadMaterial(params) {
    return request(`/material/draft/list`, {
        method: 'GET',
        params
    });
}

export function deleteMaterial(params) {
    return request(`/material/draft/delete?materialDraftId=${params.id}`, {
        method: 'DELETE',
        params:{
            materialDraftId: params.id
        }
    });
}

export function getAllCategory(params) {
    return request(`/material/category/one/list`, {
        method: 'GET',
    });
}
export function getSizeList(params) {
    return request(`/material/size/list`, {
        method: 'GET',
    });
}

export function getResemble(params) {
    return request(`/material/resemble`, {
        method: 'GET',
        params:{
            materialId: params.id
        }
    });
}

export function getAllMateiralAuthor() {
    return request(`/material/designer/list`, {
        method: 'GET',
    });
}

export function getMateiralByAuthor(params) {
    return request(`/material/designer`, {
        method: 'GET',
        params
    });
}
export function getAllFormat(params) {
    return request(`/material/format/list`, {
        method: 'GET',
        params
    });
}
export function getAuthorizedList(params) {
    return request(`/material/empower`, {
        method: 'GET',
        params
    });
}

// 获取颜色列表
export function getMaterialColorList() {
    return request('/image/color/list', {
        method: 'GET'
    });
}

// 识别图片颜色
export function recognizeMaterialColor(imageUrl) {
    return request('/image/color/recognize', {
        method: 'POST',
        data: { imageUrl }
    });
}

